import { LanguageService } from './../services/LanguageHandler'
import { receiveLanguage } from './../services/TranslateHandler'

import Home from '@/pages/home'
import AgriculturalTrainee from '@/pages/agricultural-trainee'
// import HospitalityTrainee from '@/pages/hospitality-trainee'
import Seasonal from '@/pages/seasonal'
import Static from '@/pages/static'
import NotFound from '@/pages/not-found'
import Login from '@/pages/auth/login'
import Registration from '@/pages/auth/registration'
import PartnerRegistration from '@/pages/auth/partners'
import ForgotPassword from '@/pages/auth/forgot-password'
import RestoreAccount from '@/pages/auth/restore-account'
import NewPassword from '@/pages/auth/new-password'
import Categories from '@/pages/categories'
import Profile from '@/pages/profile'
import MyJobs from '@/pages/profile/jobs'
import Job from '@/pages/profile/jobs/job'
import JobResponse from '@/pages/profile/jobs/response'
import MyCVS from '@/pages/profile/cvs'
import jobseekerCV from '@/pages/cv'
import CV from '@/pages/profile/cvs/cv'
import Favorites from '@/pages/favorites'
import Workers from '@/pages/search/workers'
import AccountPlan from '@/pages/choose-account-plan'
import Countries from '@/pages/countries'
import Country from '@/pages/countries/country'
import Contacts from '@/pages/contacts'
import FindJob from '@/pages/search/find-job'
// import HowWeWork from '@/pages/how-we-work'
import Vacancy from '@/pages/vacancy'
// import Prices from '@/pages/prices'
// import PaperWork from '@/pages/prices/paper-work'
// import PersonalMatch from '@/pages/prices/personal-match'
import ViewCV from '@/pages/profile/cvs/cv-view'
import Invoice from '@/pages/billing/invoice'
import BoughtServices from '@/pages/billing/bought-services'
import Cabinet from '@/pages/billing/cabinet'
import Dashboard from '@/pages/dashboard'
import FindCountries from '@/pages/find/countries'
import FindCategories from '@/pages/find/countries/categories'
import EmailVarificationHook from '@/pages/hooks/registration-email-verification'
import PasswordRecoveryHook from '@/pages/hooks/password-recovery-verification'
import ActivateAccountHook from '@/pages/hooks/activate-account-confirmation'
import SocialNewUserHook from '@/pages/hooks/social-new-user'
import SocialAuthLoginHook from '@/pages/hooks/social-auth-login'
import AboutUS from '@/pages/about-us'
import { gettext } from '@/services/TranslateHandler'

let currentLanguage = LanguageService.getLanguage()
const toastr = require('toastr')
const JWTDecode = require('jwt-decode')

receiveLanguage(currentLanguage)

/**
 * Middleware for route guards
 *
 * @param router object
 * @param message object [optional]
 * @param excludes array [optional]
 * @param authorized bool [optional]
 * @param redirect string [optional]
 */
function guard ({router, message, excludes, authorized = false, redirect}) {
  let auth
  try {
    auth = {
      type: (JWTDecode(localStorage.getItem('jwt_auth_token'))).profile_type
    }
  } catch (e) {
    auth = {}
  }
  let blockRoles = excludes ? excludes.indexOf((auth || {}).type) !== -1 : false
  let access = (((authorized && (auth || {}).type) || (!authorized ^ !!(auth || {}).type)) && !blockRoles)
  if (access) {
    router.next()
  } else {
    if (!(auth || {}).type && access) {
      router.next()
    } else if (!router.from.name) {
      if (message) toastr[message.type](message.text)
      router.next(redirect || router.from.path)
    } else {
      if (message) toastr[message.type](message.text)
      if (redirect) router.next(redirect)
    }
  }
}

export default {
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: `/${currentLanguage}/`
    },
    {
      path: '/:lang',
      pathToRegexpOptions: { strict: true },
      redirect: { name: 'Home' }
    },
    {
      path: '/:lang/',
      name: 'Home',
      component: Home,
      pathToRegexpOptions: { strict: true }
    },
    {
      path: '/:lang/about-us',
      name: 'AboutUS',
      component: AboutUS
    },
    {
      path: '/:lang/seasonal',
      name: 'Seasonal',
      component: Seasonal
    },
    {
      path: '/:lang/agricultural-trainee',
      name: 'AgriculturalTrainee',
      component: AgriculturalTrainee
    },
    // {
    //   path: '/:lang/hospitality-trainee',
    //   name: 'HospitalityTrainee',
    //   component: HospitalityTrainee
    // },
    {
      path: '/:lang/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You are already logged!')}
        })
      }
    },
    {
      path: '/:lang/registration',
      name: 'Registration',
      component: Registration,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You are already registered!')}
        })
      }
    },
    {
      path: '/:lang/partner-registration',
      name: 'PartnerRegistration',
      component: PartnerRegistration,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You are already registered!')}
        })
      }
    },
    {
      path: '/:lang/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You are already logged!')}
        })
      }
    },
    {
      path: '/:lang/restore-account',
      name: 'RestoreAccount',
      component: RestoreAccount,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You are already logged!')}
        })
      }
    },
    {
      path: '/:lang/new-password',
      name: 'NewPassword',
      component: NewPassword,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You are already logged!')}
        })
      }
    },
    {
      path: '/:lang/profile/cvs',
      name: 'MyCVS',
      component: MyCVS,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [20],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/profile/jobs',
      name: 'MyJobs',
      component: MyJobs,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [10],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/profile/jobs/response/:id',
      name: 'JobResponse',
      component: JobResponse,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [10],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/profile/jobs/create',
      name: 'CreateJob',
      component: Job,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [10],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/profile/jobs/:id/edit',
      name: 'EditJob',
      component: Job,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [10],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('Please authorize first!')},
          authorized: true,
          redirect: `/${currentLanguage}/login`
        })
      }
    },
    {
      path: '/:lang/profile/cvs/create',
      name: 'CreateCV',
      component: CV,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [20],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/profile/cvs/:id/edit',
      name: 'EditCV',
      component: CV,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [20],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/profile/cabinet',
      name: 'Cabinet',
      component: Cabinet,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [10],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [10, 20],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/profile/cvs/:id',
      name: 'ViewCV',
      component: ViewCV,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('You don`t have permissions!')},
          excludes: [20],
          authorized: true
        })
      }
    },
    {
      path: '/:lang/cv/:id',
      name: 'jobseekerCV',
      component: jobseekerCV
    },
    {
      path: '/:lang/favorites',
      name: 'Favorites',
      component: Favorites
    },
    {
      path: '/:lang/search/workers',
      name: 'Workers',
      component: Workers
    },
    {
      path: '/:lang/account-plan',
      name: 'AccountPlan',
      component: AccountPlan
    },
    {
      path: '/:lang/countries',
      name: 'Countries',
      component: Countries
    },
    {
      path: '/:lang/countries/country/:country',
      name: 'Country',
      component: Country
    },
    {
      path: '/:lang/categories',
      name: 'Categories',
      component: Categories
    },
    {
      path: '/:lang/contacts',
      name: 'Contacts',
      component: Contacts
    },
    {
      path: '/:lang/search/find-job',
      name: 'FindJob',
      component: FindJob
    },
    {
      path: '/:lang/find/countries',
      name: 'FindCountries',
      component: FindCountries
    },
    {
      path: '/:lang/find/categories',
      name: 'FindCategories',
      component: FindCategories
    },
    // {
    //   path: '/:lang/how-we-work',
    //   name: 'HowWeWork',
    //   component: HowWeWork
    // },
    {
      path: '/:lang/404',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/:lang/job/:id',
      name: 'Vacancy',
      component: Vacancy
    },
    // {
    //   path: '/:lang/prices',
    //   name: 'Prices',
    //   component: Prices
    // },
    // {
    //   path: '/:lang/prices/paper-work',
    //   name: 'PaperWork',
    //   component: PaperWork
    // },
    // {
    //   path: '/:lang/prices/personal-match',
    //   name: 'PersonalMatch',
    //   component: PersonalMatch
    // },
    {
      path: '/:lang/invoice',
      name: 'Invoice',
      component: Invoice,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('First you need to login!')},
          authorized: true
        })
      }
    },
    {
      path: '/:lang/bought-services',
      name: 'BoughtServices',
      component: BoughtServices,
      beforeEnter: (to, from, next) => {
        guard({
          router: {to, from, next},
          message: {type: 'warning', text: gettext('First you need to login!')},
          authorized: true
        })
      }
    },
    {
      path: '/-hook/registration-email-verification-jobseeker',
      name: 'EmailVarificationJobseekerHook',
      component: EmailVarificationHook,
      props: {employer: false}
    },
    {
      path: '/-hook/registration-email-verification-company',
      name: 'EmailVarificationCompanyHook',
      component: EmailVarificationHook,
      props: {employer: true}
    },
    {
      path: '/-hook/password-recovery-verification',
      name: 'PasswordRecoveryHook',
      component: PasswordRecoveryHook
    },
    {
      path: '/-hook/activate-account-confirmation',
      name: 'ActivateAccountHook',
      component: ActivateAccountHook
    },
    {
      path: '/-hook/social-new-user',
      name: 'SocialNewUserHook',
      component: SocialNewUserHook
    },
    {
      path: '/-hook/social-auth-login',
      name: 'SocialAuthLoginHook',
      component: SocialAuthLoginHook
    },
    {
      path: '/-hook/clear-storage',
      name: 'ClearStorageHook',
      beforeEnter: (to, from, next) => {
        localStorage.clear()
        next('/')
      }
    },
    {
      path: '/:lang/*',
      name: 'Static',
      component: Static
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/index.js